
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/layout/Header/CheckBalance/styles.less?modules";
export default {"ml_30": `ml_30-2b-Ys226`,"ml_4": `ml_4-buB6uuto`}
